import React, { FC } from 'react';
import { Icon, IconProps } from '../Icon';

export const Doc: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path
      fill="currentColor"
      d="M5.714 26.679V5.32A2.321 2.321 0 0 1 8.036 3h6.036c6.666 0 12.07 5.405 12.07 12.071V26.68A2.321 2.321 0 0 1 23.823 29H8.036a2.321 2.321 0 0 1-2.322-2.321ZM15.93 22.5a.929.929 0 1 1 0 1.857h-4.643a.929.929 0 1 1 0-1.857h4.643Zm4.643-3.714a.929.929 0 0 1 0 1.857h-9.286a.929.929 0 0 1 0-1.857h9.286Zm-1.858-8.822c0 .257.208.465.465.465h1.857c.876 0 1.7.22 2.42.609a10.248 10.248 0 0 0-5.352-5.353c.389.721.61 1.546.61 2.422v1.857ZM7.572 26.68c0 .256.207.464.464.464h15.786a.464.464 0 0 0 .464-.464V15.536a3.25 3.25 0 0 0-3.25-3.25h-1.857a2.321 2.321 0 0 1-2.322-2.322V8.107a3.25 3.25 0 0 0-3.25-3.25H8.036a.464.464 0 0 0-.464.464V26.68Z"
    />
  </Icon>
);
